import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = (metaData) => {
  const location = useLocation();
  const currentUrl = `${window.location.origin}${location.pathname}`;

  return (
    <Helmet>
      <title>{metaData?.title || ""}</title>

      <meta name="description" content={metaData?.seo?.metaDescription || ""} />
      <meta
        name="keywords"
        content={metaData?.seo?.keywords?.join(", ") || ""}
      />
      <meta property="og:title" content={metaData?.seo?.ogTitle || ""} />
      <meta
        property="og:description"
        content={metaData?.seo?.ogDescription || ""}
      />
      <meta property="og:url" content={currentUrl || ""} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaData?.title || ""} />
      <meta
        name="twitter:description"
        content={metaData?.seo?.metaDescription || ""}
      />
    </Helmet>
  );
};

export default SEO;
